import React from 'react';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/DEPRECATED/components/form/layout'. 'app/webpack/javascripts/shared/DEPRECATED/components/form/layout.js' implicitly has an 'any' type.
import { FormLabel } from 'shared/DEPRECATED/components/form/layout';
import t from 'shared/utils/translation';
import styled from 'styled-components';
import { colors } from '@grnhse/seedling/lib/azalea/constants';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/tooltips/description_tooltip'. 'node_modules/@grnhse/seedling/lib/azalea/components/tooltips/description_tooltip.js' implicitly has an 'any' type.
import DescriptionTooltip from '@grnhse/seedling/lib/azalea/components/tooltips/description_tooltip';
import { LockIcon } from '@grnhse/seedling/lib/azalea/icons';

import {
  CustomFlexContainer,
  ItalicDescription,
  MediumGrey,
  // @ts-expect-error - TS7016 - Could not find a declaration file for module './consent_extension_emails/consent_extension_email.styles'. 'app/webpack/javascripts/gdpr/components/consent_extension_emails/consent_extension_email.styles.js' implicitly has an 'any' type.
} from './consent_extension_emails/consent_extension_email.styles';
import { ConsentDecisionButtons } from './consent_extension_emails/consent_decision_buttons';

type Props = {
  approveText: string;
  bodyText: string;
  denyText: string;
  tooltipText: string;
};

const EmailTemplateFooter = (props: Props) => {
  const { approveText, bodyText, denyText, tooltipText } = props;

  return (
    <React.Fragment>
      <CustomFlexContainer marginTop={15} marginBottom={0}>
        <TitleContainer>
          <FormLabelSmall>{t('gdpr.email_footer.header')}</FormLabelSmall>
        </TitleContainer>
        <IconContainer>
          <LockIcon />
          <DescriptionTooltip text={tooltipText} />
        </IconContainer>
      </CustomFlexContainer>
      <CardHeaderContainer>
        <ItalicDescription>
          <BodyText>{bodyText}</BodyText>
        </ItalicDescription>
        <ConsentDecisionButtons approveText={approveText} denyText={denyText} />
      </CardHeaderContainer>
    </React.Fragment>
  );
};

const CardHeaderContainer = styled.header`
  border-radius: 3px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: ${colors.lightestGrey};
  border: 1px solid ${colors.lightGrey};
  position: relative;
  box-sizing: border-box;
  font-size: 20px;
  padding: 20px 19px;
`;

const FormLabelSmall = styled(FormLabel)`
  font-size: 12px;
  margin-bottom: 3px;
`;

const IconContainer = styled.div`
  margin-bottom: 4px;
  display: flex;
`;

const TitleContainer = styled.div`
  width: 100%;
`;

const BodyText = styled(MediumGrey)`
  white-space: pre-line;
`;

export default EmailTemplateFooter;
